import React from "react";
import Fit from "./Fit";
import "./HeldUp.scss";

const HeldUpCopy = () => {
  return <Fit />;
};
export default HeldUpCopy;
